<template>
    <q-page padding class="column items-center q-gutter-md">
        <div class="col-1 full-width">
            <h5 class="q-ma-sm">Шаблоны</h5>
        </div>
        <div class="col-1 full-width">
            <q-form class="row q-gutter-sm justify-center" @submit.prevent="createTemplate">
                <div class="col-10">
                    <q-file v-model="newTemplate" label="Файл шаблона"
                            accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document" filled
                            dense :rules="[requiredRule]"/>
                </div>
                <div class="col-1 ">
                    <q-btn color="primary" label="Добавить" type="submit"/>
                </div>
            </q-form>
        </div>
        <div class="col-10 full-width">
            <q-list v-if="!isFetching">
                <q-item v-for="template in templates" :key="template.id">

                    <q-item-section>
                        <q-item-label>{{ template.name }}</q-item-label>
                    </q-item-section>


                    <q-item-section side>
                        <q-btn icon="delete" color="primary" @click="deleteTemplate(template.address)"/>
                    </q-item-section>
                </q-item>
            </q-list>
        </div>
    </q-page>
</template>

<script setup lang="ts">
import {useCreateProjectTemplate, useDeleteProjectTemplate, useProjectTemplates} from "../composables/project";
import {useRoute} from "vue-router";
import {ref} from "vue";
import {requiredRule} from "../util/rules";
import {useQuasar} from "quasar";
import {useRouteParams} from "@vueuse/router";

const route = useRoute()
const $q = useQuasar()
const email = ref("")
const newTemplate = ref<Blob | null>(null)
const projectId = useRouteParams('projectId', undefined, {transform: Number})
const {isFetching, data: templates, execute} = useProjectTemplates(projectId)


async function deleteTemplate(address: string) {
    $q.dialog({
        title: 'Удаление шаблона',
        message: 'Вы уверены что хотите удалить этот шаблон?',
        cancel: true,
        persistent: true
    }).onOk(async () => {
        await useDeleteProjectTemplate(projectId, address)
        await execute()
    })

}

async function createTemplate() {
    const request = new FormData()
    const blob = newTemplate.value
    if (blob) {
        request.append('template', blob)
        $q.dialog({
            title: 'Добавление шаблона',
            message: 'Введите имя шаблона',
            prompt: {
                model: '',
                isValid: val => val.length > 2, // << here is the magic
                type: 'text' // optional
            },
            cancel: true,
            persistent: true
        }).onOk(async data => {
            request.append('name', data)
            await useCreateProjectTemplate(projectId, request)
            await execute()
        })

    }

}
</script>

<style scoped>

</style>